import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-program-description',
  standalone: false,
  templateUrl: './program-description.component.html',
  styleUrls: ['./program-description.component.scss']
})
export class ProgramDescriptionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
